import beverageV4Src from '../../assets/beverageV4/beveragesV4.png';

export const messageTypes = {
  Text: 'text',
  Image: 'image',
};

export const cantReadBeveragesMessage = 'Oops. Seems like we did not catch the beverages. Could you specify them again please? 😔';

export const notLoggedInMessage = 'Uh oh! It looks like you are not logged in. Let’s fix that.';

export const consentSaveFailedMessage = 'Uh oh! We couldn’t save that. Mind trying again?';

export const logMeInMessage = 'Log me in!';

export const saveMessage = 'Yes, please! Save my favorite sip to my profile 😃';

export const optMessage = 'We are curious 🤔 Is it okay with you if we provide onsite personalization?';

export const savedMessage = 'Success! We’ve saved your favorite sip to your Bonvoy Profile.';

export const successMessage = `Wonderful! Just so you know, preferences can be updated at any time in your <a  href="https://www.marriott.com/loyalty/myAccount/default.mi" target="_blank">Bonvoy Account Profile</a>,and you can learn more about how your data is collected and used in the <a href="https://www.marriott.com/about/privacy.mi" target="_blank">Global Privacy Statement</a>.`;

export const gotItMessage = 'Got it 👍 thanks!';

export const repeatMessage = 'This is exciting! Thanks for sharing your fav sips with us. Tell us another?';

export const beverageInitialMessages = [{
  isBot: true,
  messageType: messageTypes.Text,
  message: 'Hi! Your Marriott Bonvoy Assistant here 👋',
}, {
  isBot: true,
  messageType: messageTypes.Image,
  imageSrc: beverageV4Src,
}, {
  isBot: true,
  messageType: messageTypes.Text,
  message: 'Coffee to kickstart or a cocktail to unwind – what drink(s) would make your day?'
}];

export const beverageStep1Messages = [{
  isBot: false,
  messageType: messageTypes.Text,
  message: 'Let’s do it!'
}, {
  isBot: true,
  messageType: messageTypes.Text,
  message: 'Great! So, what are you sipping on? Share what you enjoy and when you enjoy it 🌤️️'
}];

export const beverateStep4Messages = [{
  isBot: true,
  messageTypes: messageTypes.Text,
  message: 'The perfect time! 👏🏻',
}, {
  isBot: true,
  messageType: messageTypes.Text,
  message: 'Would you like us to save your favorite sip to your Bonvoy Profile?'
}];

export const saveMessages = [{
  isBot: false,
  messageType: messageTypes.Text,
  message: saveMessage
}]

export const savedMessages = [{
  isBot: true,
  messageType: messageTypes.Text,
  message: savedMessage
}]

export const beverageOptMessages = [{
  isBot: true,
  messageType: messageTypes.Text,
  message: optMessage
}];

export const beverageSuccessMessages = [{
  isBot: true,
  messageType: messageTypes.Text,
  message: successMessage
}];

export const beverageGotItMessages = [{
  isBot: false,
  messageType: messageTypes.Text,
  message: gotItMessage
}, {
  isBot: true,
  messageType: messageTypes.Text,
  message: repeatMessage
}];

export const beverageActionTypes = {
  Start: 'start',
  Text: 'text',
  TextDisabled: 'textDisabled',
  Time: 'time',
  SaveProfile: 'saveProfile',
  Login: 'login',
  LoginSuccess: 'loginSuccess',
  OnsitePersonalization: 'onsitePersonalization',
  ThankYou: 'thankYou',
  Repeat: 'repeat',
};

export const beverageActionTypesStepMap = {
  [beverageActionTypes.Start]: 0,
  [beverageActionTypes.Text]: 1,
  [beverageActionTypes.TextDisabled]: 2,
  [beverageActionTypes.Time]: 3,
  [beverageActionTypes.SaveProfile]: 4,
  [beverageActionTypes.Login]: 5,
  [beverageActionTypes.LoginSuccess]: 6,
  [beverageActionTypes.OnsitePersonalization]: 7,
  [beverageActionTypes.ThankYou]: 8,
  [beverageActionTypes.Repeat]: 9,
};

export const beverageStepMessages = {
  [beverageActionTypesStepMap[beverageActionTypes.Start]]: beverageInitialMessages,
  [beverageActionTypesStepMap[beverageActionTypes.Text]]: beverageStep1Messages,
  [beverageActionTypesStepMap[beverageActionTypes.OnsitePersonalization]]: beverageOptMessages,
  [beverageActionTypesStepMap[beverageActionTypes.ThankYou]]: beverageSuccessMessages,
  [beverageActionTypesStepMap[beverageActionTypes.Repeat]]: beverageGotItMessages,
}

export const beverageActions = {
  [beverageActionTypesStepMap[beverageActionTypes.Start]]: {
    type: beverageActionTypes.Start,
  },
  [beverageActionTypesStepMap[beverageActionTypes.Text]]: {
    type: beverageActionTypes.Text,
  },
  [beverageActionTypesStepMap[beverageActionTypes.TextDisabled]]: {
    type: beverageActionTypes.TextDisabled,
  },
  [beverageActionTypesStepMap[beverageActionTypes.Time]]: {
    type: beverageActionTypes.Time,
  },
  [beverageActionTypesStepMap[beverageActionTypes.SaveProfile]]: {
    type: beverageActionTypes.SaveProfile,
  },
  [beverageActionTypesStepMap[beverageActionTypes.Login]]: {
    type: beverageActionTypes.Login
  },
  [beverageActionTypesStepMap[beverageActionTypes.OnsitePersonalization]]: {
    type: beverageActionTypes.OnsitePersonalization,
  },
  [beverageActionTypesStepMap[beverageActionTypes.ThankYou]]: {
    type: beverageActionTypes.ThankYou,
  },
  [beverageActionTypesStepMap[beverageActionTypes.Repeat]]: {
    type: beverageActionTypes.Repeat,
  }
};

export const timesMap = {
  morning: 'Morning 🌅',
  afternoon: 'Afternoon 🌤',
  evening: 'Evening 🌙',
  anytime: 'Anytime ⏳',
};